import Anchor from "../../../../lib/html5-software-library/src/ranj/layout/Anchor";

export default class DisplayObjectUtil {
    /**
     * Sets the registration point of given display object to given anchor
     * @param {createjs.DisplayObject} displayObject 
     * @param {Anchor|createjs.Point} anchor 
     * @returns {createjs.DisplayObject}
     */
    static anchorDisplayObject(displayObject, anchor) {
        const bounds = displayObject.getBounds() || displayObject.nominalBounds || new createjs.Rectangle(0, 0, 0, 0);
        displayObject.regX = bounds.width * anchor.x;
        displayObject.regY = bounds.height * anchor.y;

        return displayObject;
    }
}